
import Search from '../FormControls/Search'
import { REQUIRED, OPTIONAL } from '../../helpers/form'
import { isObjectNotUndefinedHasProps } from '../../helpers/object'
import { isArrayWithLength } from '../../helpers/types'
import SelectWithOptionsSearchItem from './SelectWithOptionsSearchItem'
import SelectWithInputCustomContent from './SelectWithInputCustomContent'
export default {
  name: 'SelectWithOptionsSearchItemsObject',
  components: {
    SelectWithInputCustomContent,
    SelectWithOptionsSearchItem,
    Search,
  },
  props: {
    optionsMaxWidth: {
      type: String,
      default: '100%',
    },
    changeField: {
      type: Function,
      default: null,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    searchByProp: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default() {
        return []
      },
    },
    initialValue: {
      type: Object || null,
      default: null,
    },
    fieldType: {
      type: String,
      default: REQUIRED,
    },
    nameField: {
      type: String,
      default: 'name',
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
    selectAllText: {
      type: String,
      default: 'Select All',
    },
    height: {
      type: Number,
      default: 48,
    },
    placeholder: {
      type: String,
      default: 'Name',
    },
    listLeftPadding: {
      type: String,
      default: '12px',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    showValidationErrorMessage: {
      type: Boolean,
      default: false,
    },
    validationErrorMessage: {
      type: String,
      default: 'Validation error',
    },
    searchAutoFocusOnExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      query: '',
      focusOnSearch: false,
      model: null,
      expand: false,
      clearSearch: false,
      rules: [
        (value) =>
          this.fieldType === OPTIONAL ||
          (this.fieldType === REQUIRED && !!value) ||
          'Field is required',
      ],
    }
  },
  computed: {
    inputContent() {
      const nameField = this.nameField
      const {
        model = {},
        selectAll = false,
        selectAllText = '',
        placeholder = '',
      } = this
      return model && isObjectNotUndefinedHasProps(model)
        ? model[nameField]
        : !selectAll
        ? placeholder
        : selectAllText
    },
    placeholderClass() {
      const { placeholder = '', inputContent = '' } = this
      return inputContent === placeholder
    },
    searchedItems: {
      get() {
        const { query = '', searchByProp = '', model = {} } = this
        if (!query || !searchByProp) {
          return this.items
        }

        let filtered = this.items.filter((item) => {
          // eslint-disable-next-line no-prototype-builtins
          if (!item.hasOwnProperty(searchByProp)) {
            return false
          }
          const formattedItem = item[searchByProp].toLowerCase()
          const formattedQuery = query ? query.toLowerCase() : ''
          return formattedItem.includes(formattedQuery)
        })
        if (
          isArrayWithLength(filtered) &&
          isObjectNotUndefinedHasProps(model) &&
          model?.id
        ) {
          const filteredCopy = [...filtered]
          const index = filteredCopy.findIndex((item) => item.id === model.id)
          if (index !== -1) {
            filteredCopy.unshift(model)
            const filteredSet = new Set(filteredCopy)
            filtered = [...filteredSet]
          }
        }
        return filtered
      },
      set() {},
    },
  },
  watch: {
    expand: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.clearSearch = !this.clearSearch
          this.focusOnSearch = false
          return false
        }
        if (this.searchAutoFocusOnExpand) this.focusOnSearch = true
      },
    },
    dialog: {
      immediate: true,
      handler(value) {
        this.model = value ? this.initialValue : null
      },
    },
    initialValue: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.model = newValue
        }
      },
    },
  },
  methods: {
    selectAllClickHandler() {
      this.model = null
      if (this.changeField) {
        this.changeField(null)
      }
      this.$emit('on-change-field', null)
      this.displayOptionsList()
    },
    setModel(value) {
      if (value) {
        const items = [...this.items]
        if (items.length) {
          const index = items.findIndex((item) => item.id === value)
          if (index !== -1) {
            this.model = items[index]
            if (this.changeField) {
              this.changeField(this.model.id)
            }
            this.$emit('on-change-field', this.model.id)
            this.displayOptionsList()
          }
        }
        this.searchedItems = []
      }
    },
    displayOptionsList() {
      if (!this.expand) {
        this.clearSearch = !this.clearSearch
        this.query = ''
      }
      if (this.$refs.itemsListScroll) {
        this.$refs.itemsListScroll.scrollIntoView('#item__0', 0)
      }
      this.expand = !this.expand
    },
    queryReset() {
      this.query = ''
    },
    search(searchQuery) {
      this.query = searchQuery
    },
  },
}
